/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A role a user holds in one organization.
 * @export
 * @interface OrganizationRoleRead
 */
export interface OrganizationRoleRead {
    /**
     * 
     * @type {number}
     * @memberof OrganizationRoleRead
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRoleRead
     */
    name: string;
}

/**
 * Check if a given object implements the OrganizationRoleRead interface.
 */
export function instanceOfOrganizationRoleRead(value: object): value is OrganizationRoleRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationRoleReadFromJSON(json: any): OrganizationRoleRead {
    return OrganizationRoleReadFromJSONTyped(json, false);
}

export function OrganizationRoleReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationRoleRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OrganizationRoleReadToJSON(json: any): OrganizationRoleRead {
    return OrganizationRoleReadToJSONTyped(json, false);
}

export function OrganizationRoleReadToJSONTyped(value?: OrganizationRoleRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

